import React from "react";
import { Spinner100 } from "../../../../components/icons/SvgIcons";

const ACompactarRow = ({ actaNro, marcaModelo, dominio, checked, onCheck, loadingItem, permiteCompactacion }) => {
  return (
    <div className="h-20 bg-white border-b border-[#c5dfff] flex items-center px-4">
      <div className="text-[#3d4245] text-base font-semibold font-inter flex-[0.5]">
        {actaNro}
      </div>
      <div className="text-[#3d4245] text-base font-semibold font-inter flex-1 text-center">
        {marcaModelo}
      </div>
      <div className="text-[#3d4245] text-base font-semibold font-inter flex-1 text-center">
        {dominio}
      </div>
      <div className="flex justify-center flex-[0.5]">
        {permiteCompactacion === false ? (
          <p className="text-[#3d4245] text-xs sm:text-base font-inter">
            Juzgado no permite compactar
          </p>
        ) : loadingItem ? (
          <Spinner100 className="w-6 h-6 text-white animate-spin fill-[#0477ad]" />
        ) : (
          <input
            type="checkbox"
            checked={checked}
            onChange={onCheck}
            className="cursor-pointer w-7 h-7 rounded border-2 border-[#0477ad] bg-white focus:outline-none focus:ring-0"
          />
        )}
      </div>
    </div>
  );
};

export default ACompactarRow;
